import http from "../config/http-configs";
import {configJson} from "@/api/config/http-configs";

export const employeeLogin = (name, passwd) => {
    const url = '/mobile/employee/login/name'
    const data = {loginName: name, loginPassword: passwd}
    return http.post(url, data, configJson)
}

export const employeeUpdate = (employee) => {
    const url = '/mobile/employee/update'
    return http.post(url, employee, configJson)
}

export const getEmployeeByCode = (employeeCode) => {
    const url = `/mobile/employee/info/${employeeCode}`
    return http.get(url)
}

export const getEmployeeByBatch = (employeeCodes) => {
    const url = `/mobile/employee/info/batch?employeeCodes=${employeeCodes}`
    return http.post(url, null, configJson)
}

export const getSearchEmployee = (employee) => {
    const url = '/mobile/employee/search'
    return http.post(url, employee, configJson)
}

